'use es6';

import * as colors from 'HubStyleTokens/colors';
import { ERROR, WARNING, INFO, SUCCESS } from 'DesignData/enums/EditorErrorTypes';
export const ERROR_CONSOLE_COLORS = Object.freeze({
  [ERROR]: colors.ALERT_DANGER,
  [WARNING]: colors.MARIGOLD,
  [INFO]: colors.FLINT,
  [SUCCESS]: colors.OZ
});